import Image from '@jetshop/ui/Image';
import React from 'react';
import { PushPrice } from '../../ui/StyledPrice';
import {
  Container,
  Header,
  Product,
  ProductCheckoutContainer,
  ProductDetails,
  ProductImageWrapper,
  ProductName
} from '../AddToCart/ProductToast';
import t from '@jetshop/intl';

export const PackageToast = ({ product }) => {
  return (
    <Container data-testid="package-toast">
      <ProductCheckoutContainer>
        <Product>
          {product.images.length > 0 && (
            <ProductImageWrapper>
              <Image
                src={product?.images?.[0]?.url}
                sizes={80}
                aspect={'1:1'}
                alt={product.images?.[0]?.alt}
                quality={80}
              />
            </ProductImageWrapper>
          )}
          <ProductDetails>
            <Header>{t('Added to bag')}</Header>

            <ProductName>{product.name}</ProductName>
            <PushPrice
              price={product?.price}
              previousPrice={product?.previousPrice}
            />
          </ProductDetails>
        </Product>
      </ProductCheckoutContainer>
    </Container>
  );
};
